import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';
import { User } from '../models/user.model';
import { Provision } from '../models/provision.model';
import { promises } from 'dns';
import { firstValueFrom, map, Observable } from 'rxjs';
import { Account } from '../models/account.model';
import { AzEnvironment, AzManagementGroup, AzTenant, AzureSubscription } from '../models/azureSubscription.model';


@Injectable({
  providedIn: 'root'
})
export class ProvisionsService {
  user: User;

  constructor(private httpClient: HttpClient,
    private userService: UserService) {
    this.user = userService.getUser();
  }

  getProvisions() {
    return this.httpClient.get<Array<Provision>>(environment.provisionerUrl + '/aws/provision/allprovisions');
  }

  async getAccountsByAsms(asmsId: string) {

    const data = await firstValueFrom(this.httpClient.get<any[]>(`${environment.provisionerUrl}/aws/account/accountsbyasms?asms=${asmsId}`))
    return data;
  }

  getAccountsByCreator() {
    return this.httpClient.get(`${environment.provisionerUrl}/aws/account/accountsbycreator`);
  }

  createAccount(accountCreation: any) {
    return this.httpClient.post(environment.provisionerUrl + `/aws/account/createAccount`, accountCreation)
  }

  getAzEnvs() {
    return this.httpClient.get<AzEnvironment[]>(`${environment.provisionerUrl}/azure/environments`);
  }

  getAzTenants() {
    return this.httpClient.get<AzTenant[]>(`${environment.provisionerUrl}/azure/tenants`);
  }

  getAzManagementGroups(tenantId: string) {
    return this.httpClient.get<AzManagementGroup[]>(`${environment.provisionerUrl}/azure/managementGroups/${tenantId}`);
  }

  createAzSubscription(payload: AzureSubscription) {
    return this.httpClient.post(`${environment.provisionerUrl}/azure/tfkickoff`, payload)
  }

  getAwsNameUnique(accountName: string) {
    return this.httpClient.get<boolean>(`${environment.provisionerUrl}/aws/checkUniqueAwsAccountName/${accountName}`);
  }
}